import { Box } from "@mui/material";
import {
    GridColDef,
    GridRenderCellParams,
    GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ETheme } from "../../../shared/enums/user/ETheme";
import { EditIcon, TrashIcon } from "../../../shared/icons/Icons";
import { IVersion } from "../../../shared/interfaces/version/IVersion";
import { darkTheme, lightTheme } from "../../../shared/mui/theme";
import { RootState } from "../../../store/store";

export const useVersionColumns = (
    setSelectedVersion: (version: IVersion) => void,
    setShowDeleteModal: (show: boolean) => void,
    hideActionColumn = false,
): GridColDef[] => {
    const { t } = useTranslation();
    const { userData } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    return [
        { field: "id", headerName: t("general.id"), width: 80 },
        {
            field: "version",
            headerName: t("version.name"),
            flex: 1,
            minWidth: 250,
            renderCell: (
                params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
            ) => (
                <div
                    style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                        navigate(`/version/update/${params?.row?.id}`);
                        setSelectedVersion(params?.row);
                    }}
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: "isActive",
            headerName: t("general.isActive"),
            width: 250,
            renderCell: (
                params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
            ) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    {t(`general.${params.value}`)}
                </div>
            ),
        },
        {
            field: "items",
            headerName: t("general.items"),
            width: 100,
            renderCell: (
                params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
            ) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    {params.value?.length}
                </div>
            ),
        },

        {
            field: "actions",
            headerName: t("general.action"),
            width: 150,
            sortable: false,
            renderCell: (
                params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
            ) => (
                <Box
                    sx={{
                        display: hideActionColumn ? "none" : "flex",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    {/* Edit or View Icon */}
                    <span
                        style={{ cursor: "pointer", display: "flex" }}
                        onClick={() => {
                            navigate(`/version/update/${params?.row?.id}`);
                        }}
                    >
                        <EditIcon
                            fill={
                                userData?.theme === ETheme.LIGHT
                                    ? lightTheme.palette.text.primary
                                    : darkTheme.palette.text.primary
                            }
                        />
                    </span>

                    <span
                        style={{ cursor: "pointer" }}
                        className={"ms-3 d-flex"}
                        onClick={() => {
                            setSelectedVersion(params.row);
                            setShowDeleteModal(true);
                        }}
                    >
                        <TrashIcon
                            fill={
                                userData?.theme === ETheme.LIGHT
                                    ? lightTheme.palette.text.primary
                                    : darkTheme.palette.text.primary
                            }
                        />
                    </span>
                </Box>
            ),
        },
    ];
};
